import classNames from "classnames";
import { useEffect, useRef, useState } from "react";

import { Icon } from "src/app/components/icon/Icon";

import filterCSS from "./MultiFilterDropdown.module.css";

const MultiFilterDropdown = ({
  items,
  activeItemValues,
  defaultItem,
  customCss,
  placeholder,
  handleChange,
}: {
  items: Array<any>;
  activeItemValues: Array<number> | null | undefined;
  defaultItem: string;
  customCss: string;
  placeholder: string;
  handleChange: (value: number) => void;
}) => {
  const [focused, setFocused] = useState(false);
  const searchGroup = useRef<any>(null);
  const searchInput = useRef<any>(null);
  const [inputValue, setInputValue] = useState("");
  const [filteredItems, setFilteredItems] = useState<any[]>(items);
  const [open, setOpen] = useState(false);
  const container = useRef<any>(null);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {};
  });

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (searchGroup.current && !searchGroup.current.contains(event.target as Node) && focused) {
        setFocused(false);
        setInputValue("");
      } else if (searchGroup.current && searchGroup.current.contains(event.target as Node) && !focused) {
        setFocused(true);
      }
    };
    document.addEventListener("mousedown", handleClick);
  }, [searchGroup, focused]);

  useEffect(() => {
    if (items && items.length > 0) {
      setFilteredItems(items);
    }
  }, [items]);

  useEffect(() => {
    if (inputValue) {
      setFilteredItems(items.filter((item) => item.text.toLowerCase().includes(inputValue.toLowerCase())));
    }

    return () => {
      setFilteredItems(items);
    };
  }, [inputValue, items]);

  const handleClickOutside = (event: MouseEvent) => {
    if (container.current && !container.current.contains(event.target)) {
      setOpen(false);
    }
  };

  const handleSelect = (value: number) => {
    handleChange(value);
  };

  const handleUserInput: any = (event: any) => {
    setInputValue(event.target.value);
  };

  const resetInputField = () => {
    setInputValue("");
    searchInput.current.focus();
  };

  return (
    <div className={classNames(customCss, filterCSS.dropdownContainer, open ? filterCSS.dropdownActive : "")} ref={container}>
      <div
        className={classNames("u-w100", "dropdown-button", "u-cursor-pointer", filterCSS.dropdownButton)}
        onClick={() => (items?.length > 1 ? setOpen(!open) : null)}
      >
        <span className={filterCSS.dropdownText}>
          {activeItemValues?.length === 0
            ? defaultItem
            : (items
                .filter((item) => activeItemValues?.includes(item.value))
                ?.map((item) => item.text)
                .join(", ")).length > 50
            ? items
                .filter((item) => activeItemValues?.includes(item.value))
                ?.map((item) => item.text)
                .join(", ")
                .substring(0, 50) + "..."
            : items
                .filter((item) => activeItemValues?.includes(item.value))
                ?.map((item) => item.text)
                .join(", ")}
        </span>

        <Icon name={open ? "arrow-up" : "arrow-down"} className="u-t-f24p u-t-primary u-pos-absolute u-right20px" />
      </div>
      <hr className={classNames("u-bt0", "u-zindex2", "u-bl0", "u-br0", filterCSS.lineBreak, open ? "" : "u-none")} />
      {open && (
        <div ref={searchGroup} className={classNames("dropdown-wrapper", filterCSS.dropdownWrapper)}>
          <div className={classNames("u-flex", "u-flex-content-between", "u-flex-items-center", filterCSS.searchGroupNew)}>
            <button type="button" className={classNames("u-z-index1", "u-t-black", "u-t-f15p", "", "", "u-cursor-pointer", filterCSS.searchButtonNew)}>
              <Icon name="search" className="u-t-valign-mid" />
            </button>
            <input type="text" value={inputValue} onChange={handleUserInput} placeholder={placeholder} ref={searchInput} />
            <button
              type="button"
              onClick={resetInputField}
              className={classNames(
                "u-z-index1",
                "u-t-secondary",
                "u-t-f10p",
                "u-p0",
                "u-none",
                "u-cursor-pointer",
                filterCSS.clearButtonNew,
                focused ? "" : "u-none"
              )}
            >
              <Icon name="times" className="u-t-valign-mid" />
            </button>
          </div>
          <ul className={filterCSS.dropdownMenu}>
            {filteredItems &&
              filteredItems.map((item) => (
                <Item key={item.value} item={item} activeItemValues={activeItemValues} selectItem={handleSelect} match={inputValue} />
              ))}
            {filteredItems.length === 0 && (
              <div className={filterCSS.noResultsWrap}>
                <div className={classNames("dropdown-button", filterCSS.noResults)}>
                  <span className={classNames("u-t-w400", "u-t-secondary", filterCSS.dropdownText)}>Nema rezultata</span>
                </div>
              </div>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MultiFilterDropdown;

const Item = ({
  item,
  activeItemValues,
  selectItem,
  match,
}: {
  item: any;
  activeItemValues: Array<number> | null | undefined;
  selectItem: (value: any) => void;
  match: string;
}) => {
  return (
    <li key={item.value} className={classNames("u-cursor-pointer", filterCSS.menuItem)}>
      <input type="checkbox" checked={activeItemValues?.includes(item.value)} onChange={() => selectItem(item.value)}></input>
      {!match ? (
        <span className={filterCSS.dropdownText}>{item.text}</span>
      ) : (
        <span className={filterCSS.dropdownText}>
          <strong>{item.text.slice(0, match.length)}</strong>
          {item.text.slice(match.length)}
        </span>
      )}
    </li>
  );
};
